import React              from 'react';
import classNames         from 'classnames';
import { useTranslation } from 'react-i18next';

import Preloader from '../preloader';

import SearchLine     from './components/SearchLine';
import SearchDoorItem from './components/SearchDoorItem';
import SearchInfoItem from './components/SearchInfoItem';
import SearchNewsItem from './components/SearchNewsItem';
import SearchPageItem from './components/SearchPageItem';

import { useSearch } from '../../../providers/search';

const Search = () => {
  const { t } = useTranslation();

  const search = useSearch();

  const timeOut = React.useRef(null);

  const [show, setShow]         = React.useState(false);
  const [collapse, setCollapse] = React.useState({ doors: true });

  const close          = React.useCallback(() => {
    if (show) {
      setShow(false);
    }

    setTimeout(search.searchClose, 150);
  }, [show]);
  const collapseToggle = React.useCallback((event, data) => {
    event.preventDefault();
    event.stopPropagation();

    if (collapse[data.section] !== data.state) {
      setCollapse({
          ...collapse,
          [`${data.section}`]: data.state,
        },
      );
    }
  }, [collapse]);
  const keyDown        = React.useCallback((event) => {
    if (event.key === 'Escape') {
      close();
    }
  }, [close]);
  const resetTimeOut   = React.useCallback(() => {
    if (timeOut.current) {
      clearTimeout(timeOut.current);
    }
  }, []);
  const searchItems    = React.useCallback((value) => {
    if (value.length >= 3) {
      timeOut.current = setTimeout(() => {
        search.search(value
          .toLowerCase()
          .escapeSearch(),
        );
      }, 4e2);
    }
  }, []);

  React.useEffect(() => {
    document.addEventListener('keydown', keyDown);

    return () => {
      document.removeEventListener('keydown', keyDown);
    };

  }, [show]);
  React.useEffect(() => {
    if (search.open && !show) {
      setTimeout(() => {
        setShow(true);
      }, 150);
    }
  }, [search.open]);

  if (!search.open) {
    return null;
  }

  return (
    <div
      className={classNames('search', { 'open': show })}
      onClick={close}
    >
      <div
        className={'container'}
        onClick={(event) => {
          event.preventDefault();
          event.stopPropagation();
        }}
      >
        <SearchLine
          close={close}
          reset={search.searchReset}
          resetTimeout={resetTimeOut}
          search={searchItems}
          show={show}
        />
        <div className={'result'}>
          {(
            Object.keys(search.doors).length <= 0 &&
            Object.keys(search.news).length <= 0 &&
            Object.keys(search.information).length <= 0 &&
            Object.keys(search.pages).length <= 0 &&
            search.searched &&
            !search.loading
          )
            ? <span className={'emptyResult'}>{t('query_is_false')}</span>
            : (
              <>
                <div
                  className={classNames('doors', {
                    'collapsed': search.doors.length > 2 && collapse.doors,
                  })}
                >
                  {Object
                    .values(search.doors)
                    .map((door, i) => {
                      return (
                        <SearchDoorItem
                          close={close}
                          key={i}
                          offers={door}
                        />
                      );
                    })
                  }
                  {search.doors.length > 2 && (
                    <div
                      className={'toggle'}
                      onClick={(event) => {
                        collapseToggle(event, {
                          section: 'doors',
                          state:   !collapse.doors,
                        });
                      }}
                    ><span className={'ic-arrow-bottom'} /></div>
                  )}
                </div>
                {Object
                  .values(search.news)
                  .map((item, i) => {
                    return (
                      <SearchNewsItem
                        close={close}
                        key={i}
                        {...item}
                      />
                    );
                  })
                }
                {Object
                  .values(search.information)
                  .map((item, i) => {
                    return (
                      <SearchInfoItem
                        close={close}
                        key={i}
                        {...item}
                      />
                    );
                  })
                }
                {Object
                  .values(search.pages)
                  .map((item, i) => {
                    return (
                      <SearchPageItem
                        close={close}
                        key={i}
                        {...item}
                      />
                    );
                  })
                }
              </>
            )
          }
        </div>
        {search.loading && <Preloader />}
      </div>
    </div>
  );
};
export default Search;